export const isNotEmpty = (element) =>
    element !== "" && element !== null && element !== undefined;
